export class VehiclePaintCodeProviderService {
    private static serviceInstance: VehiclePaintCodeProviderService;

    public static get instance() {
        // eslint-disable-next-line no-return-assign
        return this.serviceInstance || (this.serviceInstance = new this());
      }

      public GetPaintCode(colour: string, make: string): string {
        if (!colour || !make) {
            return '';
        }
        switch (make.toLocaleUpperCase()) {
            case 'BMW':
                return this.GetBmwPaintCode(colour);
            case 'NISSAN':
                return this.GetNissanPaintCode(colour);
            default:
                return '';
        }
    }

    private GetNissanPaintCode(colour: string): string {
        const nissanPaintCodes: { [key: string]: string } = {
            white: 'pspc0101',
            blue: 'pspc0065',
            grey: 'pspc0030',
            sliver: 'pspc0322',
            black: 'pspc0064',
            red: 'pspc0213',
            brown: 'pspc0359',
            'two-tone': 'pspc0213sspc0004'
        };

        return this.getPaintCodeFromMap(colour, nissanPaintCodes, 'pspc0322');
    }

    private GetBmwPaintCode(colour: string): string {
        const bmwPaintCodes: { [key: string]: string } = {
            grey: 'pspc0031',
            black: 'pspc0004',
            blue: 'pspc0009',
            red: '161477',
            white: 'pspc0041',
            multicolour: 'pspc0016'
        };

        return this.getPaintCodeFromMap(colour, bmwPaintCodes, 'pspc0004');
    }

    private getPaintCodeFromMap(colour: string, paintCodes: { [key: string]: string }, defaultCode: string): string {
        const normalizedColour = colour.toLocaleLowerCase();
        return paintCodes[normalizedColour] || defaultCode;
    }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const vehiclePaintCodeProviderService = VehiclePaintCodeProviderService.instance;
